import moment from 'moment';
import { capitalize, formatDuration, SummaryRow as Row } from '../../booking/BookingParts';
import { isValidCustomerDocument, useFormHorarioClienteContext } from './Context';
import { convertMinutesToHHMM } from '../../../../components/utils';
import { QrCode } from 'lucide-react';

export const FormAgendamentoConfirmacao = () => {
    const {
        estab,
        estabLocked,
        servico,
        servicosExtras,
        atendente,
        attendantCount,
        data,
        horario,
        setOpenConfirm,
        setShowHorarios,
        resetAttendant,
        paymentRequirement,
        customerCpfCnpj,
        setCustomerCpfCnpj,
    } = useFormHorarioClienteContext();
    const services = [servico, ...servicosExtras].filter((item: any) => item?.name);
    const duration = services.reduce((total: number, item: any) => total + Number(item?.duration || 0), 0);
    const requiresDocument = paymentRequirement?.requiresPayment && paymentRequirement?.requiresCustomerDocument;
    const dateLabel = capitalize(moment(data).format('dddd, DD [de] MMMM'));

    return (
        <div className="space-y-4">
            <div className="overflow-hidden rounded-2xl bg-base-100 ring-1 ring-base-content/[0.06]">
                <Row label="Data e horário" editLabel="Alterar data e horário" onEdit={() => setOpenConfirm(false)}>
                    {dateLabel} às {convertMinutesToHHMM(horario)}
                </Row>
                <Row
                    label={services.length > 1 ? 'Serviços' : 'Serviço'}
                    editLabel="Alterar serviços"
                    onEdit={() => {
                        setOpenConfirm(false);
                        setShowHorarios(false);
                    }}
                >
                    {services.map((item: any) => <div key={item?._id}>{item?.name}</div>)}
                    {!!duration && <div className="mt-0.5 text-sm font-normal text-base-content/60">{formatDuration(duration)}</div>}
                </Row>
                <Row
                    label="Profissional"
                    editLabel="Alterar profissional"
                    onEdit={(attendantCount || 0) > 1 ? () => {
                        setOpenConfirm(false);
                        resetAttendant();
                    } : undefined}
                >
                    {atendente?.displayName}
                </Row>
                {!estabLocked && <Row label="Estabelecimento">{estab?.name}</Row>}
            </div>

            {paymentRequirement?.requiresPayment && (
                <div className="flex gap-3 rounded-2xl bg-primary/10 px-4 py-3.5 text-sm leading-relaxed text-base-content/85">
                    <QrCode className="mt-0.5 text-primary" aria-hidden="true" />
                    <p>O pagamento é por Pix. Depois de gerado, o horário fica reservado por {paymentRequirement?.pixExpirationMinutes || 15} minutos.</p>
                </div>
            )}

            {requiresDocument && (
                <label className="block px-1">
                    <span className="mb-1.5 block text-sm font-medium text-base-content">CPF ou CNPJ de quem vai pagar</span>
                    <input
                        className="input input-bordered h-12 w-full rounded-xl text-base"
                        inputMode="numeric"
                        autoComplete="off"
                        value={customerCpfCnpj}
                        onChange={(event) => setCustomerCpfCnpj(event.target.value)}
                        placeholder="Somente números"
                        aria-invalid={!!customerCpfCnpj && !isValidCustomerDocument(customerCpfCnpj)}
                    />
                    <span className="mt-1.5 block text-xs text-base-content/55">Necessário para gerar o Pix.</span>
                </label>
            )}
        </div>
    );
};
